import { useEffect, useState } from 'react';

const RIGIDEZ = 0.22;
const AMORTECIMENTO = 0.72;

// Mola com velocidade e amortecimento: oscila e assenta sozinha ao passar/clicar.
// O laço de animação só roda enquanto a mola está em movimento.
export default function useElasticHover({ hover = 1.05, press = 0.97 } = {}) {
  const [el, setEl] = useState(null);

  useEffect(() => {
    if (!el) return undefined;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return undefined;

    let escala = 1;
    let vel = 0;
    let alvo = 1;
    let id = null;

    const passo = () => {
      const forca = (alvo - escala) * RIGIDEZ;
      vel = (vel + forca) * AMORTECIMENTO;
      escala += vel;
      if (Math.abs(vel) < 0.0002 && Math.abs(alvo - escala) < 0.0002) {
        escala = alvo;
        el.style.transform = escala === 1 ? '' : `scale(${escala})`;
        id = null;
        return;
      }
      el.style.transform = `scale(${escala})`;
      id = requestAnimationFrame(passo);
    };
    const mirar = (valor) => {
      alvo = valor;
      if (id === null) id = requestAnimationFrame(passo);
    };

    const onEnter = () => mirar(hover);
    const onLeave = () => mirar(1);
    const onDown = () => mirar(press);
    const onUp = () => mirar(hover);

    el.style.willChange = 'transform';
    el.addEventListener('mouseenter', onEnter);
    el.addEventListener('mouseleave', onLeave);
    el.addEventListener('mousedown', onDown);
    el.addEventListener('mouseup', onUp);
    return () => {
      if (id !== null) cancelAnimationFrame(id);
      el.removeEventListener('mouseenter', onEnter);
      el.removeEventListener('mouseleave', onLeave);
      el.removeEventListener('mousedown', onDown);
      el.removeEventListener('mouseup', onUp);
      el.style.transform = '';
      el.style.willChange = '';
    };
  }, [el, hover, press]);

  return setEl;
}
